import styled from '@emotion/styled'
import {theme} from '../../../theme'

export const StepperWrapper = styled.nav`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  background: ${theme.colors.bg.primary};
  border-radius: 100px;
  // border-bottom: 1px solid ${theme.colors.border.light};
  // box-shadow: ${theme.shadows.sm};
  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 9.9px 0px;
  // border: 1px solid #d6def0;
  overflow-x: auto;
  gap: 16px;
`

export const StepItem = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;
`

export const StepButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
  background: none;
  border: none;
  padding: 0;
  cursor: ${({isCompleted}) => (isCompleted ? 'pointer' : 'default')};
  pointer-events: ${({isCompleted}) => (isCompleted ? 'auto' : 'none')};
  text-align: left;

  // &:focus-visible {
  //   outline: 2px solid ${theme.colors.border.focus};
  //   outline-offset: 4px;
  //   border-radius: ${theme.radii.sm};
  // }
`

export const StepCircle = styled.div`
  width: 29px;
  height: 29px;
  border-radius: ${theme.radii.full};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.semibold};
  flex-shrink: 0;
  transition: background ${theme.transitions.normal},
    border ${theme.transitions.normal};

  ${({status}) => {
    if (status === 'active')
      return `
      background: #0327a9;
      color:      ${theme.colors.text.inverse};
      // border:     1px solid ${theme.colors.bg.inverse};
    `
    if (status === 'completed')
      return `
      background: #009075;
      color:      ${theme.colors.text.inverse};
      // border:     1px solid ${theme.colors.bg.inverse};
    `
    // inactive
    return `
      background: #eaeaea;
      border: 1px solid #808080
      color:      ${theme.colors.text.primary};
    `
  }}
`

export const StepMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const StepLabel = styled.span`
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.bold};
  color: ${({status}) =>
    status === 'inactive'
      ? theme.colors.text.muted
      : theme.colors.text.primary};
  white-space: nowrap;
`

export const StepSubtitle = styled.span`
  font-size: ${theme.fontSizes.xs};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.text.primary};
  white-space: nowrap;
`

export const Connector = styled.div`
  flex: 1;
  min-width: 40px;
  angle: 0 deg;
  opacity: 1;
  border-width: 1px;
  border-style: dashed;
  dashes: 4, 6;
`
